// extracted by mini-css-extract-plugin
export default {"done":"CookingTimersTray_done__GZ0lI","timer-done-pulse":"CookingTimersTray_timer-done-pulse__lqzs2"};